import React, {
  memo,
  useState,
} from 'react';

import {
  Button,
  message,
} from 'antd';
import { PiUsers } from 'react-icons/pi';

import ConfirmationModal
  from '../../../../components/Modals/ConfirmationModal/ConfirmationModal';
import { useTheme } from '../../../../context/ThemeProvider';
import {
  useUpdateTQServiceRequest,
} from '../../../../hooks/mutations/tqConnectMutations/service-requests';
import {
  TQServiceRequestStatusType,
} from '../../../../types/tqConnectTypes/service-requests';

interface Props {
  serviceRequestId: string;
  status: TQServiceRequestStatusType;
}

const MakeServiceRequestPublic: React.FC<Props> = ({
  serviceRequestId,
  status,
}) => {
  const { colors: COLORS } = useTheme();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { updateServiceRequest, isPending: isUpdating } =
    useUpdateTQServiceRequest(serviceRequestId || '');

  const makeServiceRequestPublic = () => {
    updateServiceRequest(
      {
        serviceRequestId,
        data: {
          visibility: 'public',
          // status: 'open',
        },
      },
      {
        onSuccess: () => {
          message.success('Your request is now public');
          setIsModalOpen(false);
        },
        onError: () => {
          setIsModalOpen(false);
        },
      },
    );
  };

  const hideModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="make-service-request-public">
        <p
          className="make-service-request-public__message"
          style={{ color: COLORS.TEXT1 }}>
          {status === 'rejected'
            ? "Your request wasn't picked privately this time. Make it public to reach more helpers and keep your query active?"
            : "Your private request wasn't picked yet. Keep it active by making it Public."}
        </p>
        <Button
          className="make-service-request-public__btn siteBtn darkBtn"
          onClick={() => setIsModalOpen(true)}>
          <PiUsers size={16} color="currentColor" /> Make public
        </Button>
      </div>
      <ConfirmationModal
        title="Make this request public?"
        message="By making your request public, it will be shared with the wider community so more people can see and respond."
        handleOk={makeServiceRequestPublic}
        handleCancel={hideModal}
        okayButtonText={isUpdating ? 'Making...' : 'Make public'}
        loading={isUpdating}
        open={isModalOpen}
        cancelButtonText="Cancel"
      />
    </>
  );
};

export default memo(MakeServiceRequestPublic);
